import ScalarIconCaretUp_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCaretUp.vue.script.js";
//#region src/components/ScalarIconCaretUp.vue
var ScalarIconCaretUp_default = ScalarIconCaretUp_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCaretUp_default as default };

//# sourceMappingURL=ScalarIconCaretUp.js.map